import React from "react";
import { circIn, motion, useAnimationControls } from "framer-motion";
import "./style.scss";

function HomeContent1(props) {
  const btnController = useAnimationControls();
  const textBackgroundController = useAnimationControls();
  const cellsController = useAnimationControls();
  const rocketsController = useAnimationControls();

  const width = window.innerWidth;
  const height = window.innerHeight;

  return (
    <div className="home-content1-wrapper">
      <motion.div className="home-content1">
        <motion.div
          className="home-content1-cells"
          variants={{
            hidden: {
              opacity: 0,
              transition: { duration: 3 },
            },
          }}
          animate={cellsController}
        >
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-maincell.svg"
            className="maincell"
            variants={{
              small: {
                width: "45%",
                top: "7%",
                left: "48%",
                transition: { duration: 3 },
              },
            }}
            animate={cellsController}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-backcellstar.svg"
            className="backcellstar"
            variants={{
              small: {
                left: "18%",
                transition: { duration: 3 },
              },
            }}
            animate={cellsController}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-backcell.svg"
            className="backcell"
            variants={{
              small: {
                width: "11%",
                top: "38%",
                left: "31%",
                transition: { duration: 3 },
              },
            }}
            animate={cellsController}
          />
        </motion.div>

        <motion.div className="home-content1-rockets">
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-rocket1.svg"
            className="rocketsmall"
            variants={{
              fly: {
                x: width * 0.3,
                y: -height * 0.2,
                transition: { duration: 2, ease: circIn },
              },
            }}
            animate={rocketsController}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-rocket1.svg"
            className="rocketfar"
            variants={{
              fly: {
                x: width * 0.8,
                y: -height * 1.2,
                transition: { duration: 2, ease: circIn },
              },
            }}
            animate={rocketsController}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-rocket1.svg"
            className="rocketnear"
            variants={{
              fly: {
                x: width * 0.3,
                y: -height * 0.4,
                transition: { duration: 2, ease: circIn },
              },
            }}
            animate={rocketsController}
          />
        </motion.div>

        <motion.div
          className="home-content1-text-background"
          variants={{
            hidden: {
              opacity: 0,
              transition: { duration: 3 },
            },
          }}
          animate={textBackgroundController}
        >
          <p className="home-content1-text-title">BioRocket</p>
          <p className="home-content1-text">
            Systematic Discovery of Novel Protein Delivery Systems in Massive
            Prokaryotic Genomes
          </p>
        </motion.div>

        <motion.img
          src={"https://static.igem.wiki/teams/4826/wiki/click-btn.svg"}
          variants={{
            hidden: {
              opacity: 0,
              transition: { duration: 3 },
            },
          }}
          animate={btnController}
          whileHover={{ cursor: "pointer" }}
          onClick={props.toggle}
          onTap={() => {
            btnController.start("hidden");
            textBackgroundController.start("hidden");
            rocketsController.start("fly");
            cellsController.start("small");
          }}
          style={{
            position: "absolute",
            width: "20%",
            top: "80%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10,
          }}
        ></motion.img>
      </motion.div>
    </div>
  );
}

export default HomeContent1;
